import { atom } from 'jotai';
import { atomWithStorage, useResetAtom } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';
import {
  createAppointmentIntent,
  deleteAppointmentIntent,
} from '@service-initiation/tech-care-data-access-tech-care-services';

type AppointmentIntent = {
  date: string;
  endTime: string;
  id: string;
  startTime: string;
  storeId: number;
  timeZone: string;
};

const appointmentIntentAtomWithStorage = atomWithStorage<
  AppointmentIntent | undefined
>(
  'si-tec-car-appointment-intent',
  undefined,
  storage<AppointmentIntent | undefined>(),
  {
    getOnInit: true,
  }
);

export const appointmentIntentAtom = atom<
  AppointmentIntent | undefined,
  [Omit<AppointmentIntent, 'id'>],
  Promise<void>
>(
  (get) => {
    return get(appointmentIntentAtomWithStorage);
  },
  async (get, set, value) => {
    const prevValue = get(appointmentIntentAtomWithStorage);

    const intentId = await createAppointmentIntent({
      appointmentDate: value.date,
      appointmentStartTime: value.startTime,
      storeId: value.storeId,
      storeTimeZone: value.timeZone,
    });

    if (prevValue && prevValue.id !== intentId) {
      deleteAppointmentIntent({
        appointmentDate: prevValue.date,
        appointmentStartTime: prevValue.startTime,
        intentId: prevValue.id,
        storeId: prevValue.storeId,
        storeTimeZone: prevValue.timeZone,
      });
    }

    set(appointmentIntentAtomWithStorage, { ...value, id: intentId });
  }
);

export const useResetAppointmentIntent = () => {
  const resetAppointmentIntent = useResetAtom(appointmentIntentAtomWithStorage);

  return () => {
    resetAppointmentIntent();
  };
};
